import { META_PIXEL_IDS } from './metaPixel';

const META_LEAD_UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export type MetaPixelLeadParams = {
  content_name: string;
};

function getMetaLeadUtmParams(): Record<string, string> {
  if (typeof window === 'undefined') return {};

  const params = new URLSearchParams(window.location.search ?? '');
  const out: Record<string, string> = {};

  for (const key of META_LEAD_UTM_KEYS) {
    const value = params.get(key);
    if (value) out[key] = value;
  }

  return out;
}

export function trackMetaPixelLead({ content_name }: MetaPixelLeadParams): void {
  if (typeof window === 'undefined') return;

  const eventData = {
    content_name,
    ...getMetaLeadUtmParams(),
  };

  try {
    const fbq = window.fbq;
    if (typeof fbq !== 'function') return;

    for (const pixelId of META_PIXEL_IDS) {
      fbq('trackSingle', pixelId, 'Lead', eventData);
    }
  } catch (error) {
    console.error('Error fbq Lead tracking:', error);
  }
}
